import PurechainMockup from './mockups/PurechainMockup'

function App () {
  const concept = window.location.pathname.endsWith('/mockups/memo') ? 'memo' : 'private'

  return <PurechainMockup concept={concept} />
}

export default App
